/**
 * In theme.js there is a check if the current page is a bundle page
 *
 * Look for the following in theme.js
 * this.form.classList.contains('js-bundle-form')
 */

const classes = { active: 'active' };

let document_ready = false;

const bundle_predefined_variant_elems = document.querySelectorAll('.js-bundle__predefined-variant');
const bundle_variants_elems = document.querySelectorAll('.js-bundle__variants');
const bundle_variant_elems = document.querySelectorAll('.js-bundle__variant');
const bundle_containers = document.querySelectorAll('.js-bundle__container');

const bundle_sizes = document.querySelectorAll('.js-bundle-size');
const add_to_cart = document.querySelector('.js-bundle-add-to-cart');


const bundle_data_elem = document.querySelector('#bundle-data')
const data = bundle_data_elem ? JSON.parse(bundle_data_elem.innerHTML) : null;

let customVariant = false;
let current_size = bundle_sizes.length > 0 ? [...bundle_sizes].find(x => x.checked === true).value : null;

const unset_variants_quantity = data.bundleProducts.flatMap(x => x.sizes).filter(y => y.value === 0).map(y => y.size);
//Only show unique variants
const uniqe_unset_variants_quantity = unset_variants_quantity.length > 0 ? [...new Map(unset_variants_quantity.map((item) => [item, item])).values(),] : null;

if (!data) throw new Error('No Dataset - Bundle wont work');
if (uniqe_unset_variants_quantity) throw new Error(`Some quantities are missing on the variant size(s) ${ uniqe_unset_variants_quantity.map(x => x) }`);


const updateBundle = () => {
    window.bundle = getFormData();
}


const createFormData = ({bundleId,bundleTitle,formData}) => {
    const obj = [];
    const ids = new Set(formData.items.map((item) => item.id));

    const hasMasterProduct = data.masterProduct ? [...ids].includes(String(data.masterProduct.variants[0].id)) : false;
    
    ids.forEach((id) => {
        const quantities = formData.items.filter((item) => item.id === id).map((item) => item.quantity);
        const sum = quantities.reduce((quantity, array) => quantity += array);
        const bundle = data.bundleProducts.find((bundle) => bundle.variants.find((variant) => variant.id === parseInt(id, 10)));

        if (hasMasterProduct) {
            
            const isBundleMaster = String(data.masterProduct.variants[0].id) === id;

            if (isBundleMaster) {
                obj.push({
                    "id": id,
                    "quantity": sum,
                    "properties": {
                        "Kit": String(`${ bundleTitle } - ${ current_size }`),
                        "_size": String(current_size),
                        "_bundlePatternUrl": String(`/products/${ data.masterProduct.handle }`),
                        "_bundleUrl": String(window.location.href),
                        "_bundleId": String(bundleId),
                        "_bundleMaster": isBundleMaster,
                    }
                });
            }else{
                obj.push({
                    "id": id,
                    "quantity": sum,
                    "properties": {
                        "Kit": String(`${ bundleTitle } - ${ current_size }`),
                        "_size": String(current_size),
                        "_bundleId": String(bundleId),
                        
                    }
                });
            }
        }
        else{
            obj.push({
                "id": id,
                "quantity": sum,
            });
        }
        
        

         /* Add kit contents to object if selected variant has any data related */
         if (bundle) {
            const relatedVariant = bundle.variants.find((variant) => variant.id === parseInt(id, 10));

            if (relatedVariant) {
                if (relatedVariant?.metafields?.contents) {
                    // console.log(obj);
                    obj[obj.length - 1].properties[window.theme.strings.kitContent ?? 'Hverdagskit'] = relatedVariant.metafields.contents;
                }
            }
         }

        // if (data.masterProduct) {
        //     obj.bundlePatternId = String(data.masterProduct.id),
        //     obj.bundlePatternUrl = String(`/products/${ data.masterProduct.handle }`);
        // }
    })

    return {
        items: obj.reverse()
    };
}




/**
 * Get list of selected products af formData
 */
const getFormData = () => {

    /**
     * uniqe bundle id as a timestamp
     */
    const bundleId = Date.now();
    let bundleTitle = document.querySelector('.product-single__title').textContent;
    const selected_products = document.querySelectorAll('.bundle-product:checked');

    const formData = { "items": [] };

    

    if (data.masterProduct) {
        const masterProduct = {
            "id": String(data.masterProduct.variants[0].id),
            "quantity": Number(1),
            "properties": {
                "Kit": String(`${ bundleTitle } - ${ current_size }`),
                "_size": String(current_size),
                "_bundlePatternId": String(data.masterProduct.id),
                "_bundlePatternUrl": String(`/products/${ data.masterProduct.handle }`),
                "_bundleMaster": true,
            }
        };

        /**
        * Checks if the pattern is in the drawer... if not add it, else don't
        */

        // const productCheck = window.cartItems ? window.cartItems.find(x => x.product_id === data.masterProduct.id && x.properties._size === current_size) : document.querySelectorAll(`[data-pattern-id*="${ data.masterProduct.id }"]:not([data-bundle-id])`);
        const productCheck = false
        if (!productCheck) {
            formData.items.push(masterProduct);
        }
    }

  
    data.bundleProducts.forEach((bundle_product, i) => {
        if (!selected_products[i]) return
        const id = selected_products[i].value;
        const quantity = bundle_product.sizes.find(x => x.size == current_size).value;

        const obj = {
            "id": String(id),
            "quantity": Number(quantity),
        };

        formData.items.push(obj);
    })

    const newFormData = createFormData({bundleId,bundleTitle,formData});



    return newFormData;
}


const toggleAccordion = (bool) => {
    const accordion = document.querySelector(".js-accordion");
    if (bool == false) {
        accordion.classList.remove('open')
        accordion.style.maxHeight = null;
    } else {
        accordion.classList.add('open')
        accordion.style.maxHeight = accordion.scrollHeight + "px";
    }
}

const updateTitleAndImg = (bundle_container, label, quantity, bundleLoop, img, inventoryQuantity) => {
    const container = document.getElementById(`bundle-container-${bundleLoop}`);
    const title = container.querySelector('.js-bundle-variant-title');
    const subTitle = container.querySelector('.js-bundle-variant-subtitle');

    if (title) {
        title.innerHTML = `${ label.title }`;
    }
    if (subTitle) {
        subTitle.innerHTML = `${ quantity } ${ theme.strings?.pcs }`;
    }

    if (inventoryQuantity <= 15) {
        if (container.querySelector(".few-in-stock-pil-bundle") ) {
            container.querySelector(".few-in-stock-pil-bundle").style.display = "flex";
            container.querySelector(".few-in-stock-pil-bundle").innerText = `${ inventoryQuantity } in stock`;
        }
    } else {
        if (container.querySelector(".few-in-stock-pil-bundle")) {
            container.querySelector(".few-in-stock-pil-bundle").style.display = "none";
        }
    }

    container.querySelector('img').src = img;
    

}

const getTotalPrice = (compare_at_price = false) => {

    let total_price = 0


    if (data.masterProduct) {

        let masterProductPrice = compare_at_price ? data.masterProduct.compare_at_price : data.masterProduct.price;
        total_price = data.masterProduct ? masterProductPrice : 0;
        if (compare_at_price && masterProductPrice == null) {
            total_price = data.masterProduct.price
        }
    }


    bundle_variants_elems.forEach((bundle_variants_elem, index) => {
        const product_id = bundle_variants_elem.dataset.productId;
        const bundleLoop = bundle_variants_elem.dataset.bundleLoop
        const match = data.bundleProducts[index].product_id == product_id ? data.bundleProducts[index] : null

      

        const quantity = current_size ? match.sizes.find(x => x.size == current_size).value : match.sizes[0].value;
        const checked_item = bundle_variants_elem.querySelector('.js-bundle__variant input:checked');

        if (checked_item) {
            let item_price = compare_at_price ? checked_item.dataset.compareAtPrice : checked_item.dataset.price;

            if (compare_at_price && item_price == null) {
                item_price = checked_item.dataset.price;
            }

            if (!quantity && !item_price) throw new Error('Missing price and or quantity');

            total_price = total_price + (item_price * quantity);

            const label = checked_item.nextElementSibling;
            const img = checked_item.closest('.js-bundle__variant').querySelector('img').src;


            if (document.getElementById(`BundleDrawer-${ bundleLoop }`).classList.contains("bundle-drawer--is-open")){
                document.getElementById(`BundleDrawer-${ bundleLoop }`).classList.remove("bundle-drawer--is-open");
                document.querySelector("html").classList.remove("js-drawer-open");
                if (document.querySelector(".bundle-drawer-overlay")) {
                    document.querySelector(".bundle-drawer-overlay").style.display = "none";
                }
            }

            const inventoryQuantity = checked_item.dataset.inventoryQuantity;

            console.log("inventory",inventoryQuantity)
            
            updateTitleAndImg(bundle_containers[index], label, quantity, bundleLoop, img, inventoryQuantity);
        }

    });

    return total_price;
}

const updateCurrentSize = (value) => {
    current_size = value;
    const current_size_headline_size = document.querySelectorAll('.js-bundle-current-size');
    current_size_headline_size.forEach(elem => {
        elem.innerHTML = current_size;
    });
}

/**
 * Update the total price on the product page
 */
const updateHtmlPrice = () => {
    const total_price = getTotalPrice();
    const total_compare_at_price = getTotalPrice(true);

    const bundle_price_elem = document.querySelectorAll('[data-bundle-price]');
    const bundle_compare_at_price_elem = document.querySelector('[data-price-wrapper]');

    if (!bundle_price_elem) return

    bundle_price_elem.forEach(elem => {
        elem.innerHTML = theme.Currency.formatMoney(total_price, theme.settings.moneyFormat);
    });

    if (total_compare_at_price > total_price) {

        bundle_compare_at_price_elem.classList.remove('hide');

        const compare_at_price_html = `
            <span class="product__price product__price--compare">
                ${ theme.Currency.formatMoney(total_compare_at_price, theme.settings.moneyFormat) }
            </span>`


        bundle_compare_at_price_elem.innerHTML = compare_at_price_html;
    }
    else {
        bundle_compare_at_price_elem.classList.add('hide');
    }


    if (document_ready) {
        window.bundle = getFormData();
    }
}


/**
 * looping through all products to se if there varint id matches with the predefined variant array
 */
let warning_have_been_given = false;

const bundleVariantSelectChange = (variant_arr, testing = false) => {
    let error = false;


    if (variant_arr.length > bundle_variants_elems.length && !warning_have_been_given) {
        console.warn(`There are ${ variant_arr.length } product variants to matchs, but only ${ bundle_variants_elems.length } avalable, the last ${ variant_arr.length - bundle_variants_elems.length } have been ignoret.`);
        warning_have_been_given = true;
    }

    variant_arr.forEach((current_variant_id, index) => {

        if (error) return;
        /**
         * check the console.warn above
         */
        if (index >= bundle_variants_elems.length) return;

        const current_group_elems = bundle_variants_elems[index].querySelectorAll('.js-bundle__variant input')
        const match = [...current_group_elems].find(x => x.value == current_variant_id);

        if (match && !match.disabled) {
            if (!testing) {
                match.click();
            }
        }
        else {

            error = true

            if (!testing) {
                console.warn('No matches found: ', bundle_variants_elems[index]);
            }
        }
    });

    return error;

}

/**
 * Check if predifined variants have the chosen products
 */
const invalid_predefined_varant = (predefined_variant_input, testing = false) => {
    predefined_variant_input.setAttribute('aria-disabled', 'true');

    const next_available_predefined_variant = document.querySelector('.js-bundle__predefined-variant input:not([aria-disabled="true"])');
   

    if (next_available_predefined_variant) {
        next_available_predefined_variant.checked = true;
        

        // if (next_available_predefined_variant.parentElement.classList.contains('js-bundle__predefined-variant--custom')) {
        //     toggleAccordion(true);
        // }
    }

    if (!testing) {
        alert(theme.strings.removeBundleError);
    }
}

/**
 * Looping through predefined variants - and the custom predefined variant
 */
bundle_predefined_variant_elems.forEach((predefined_variant_elem, index) => {

    const predefined_variant_input = predefined_variant_elem.querySelector('input');
    const variant_arr = predefined_variant_input.dataset.variants?.split(',');

    if (predefined_variant_input.checked) {
        bundleVariantSelectChange(variant_arr);
    }
    //Skip custom product
    if (!predefined_variant_elem.classList.contains('js-bundle__predefined-variant--custom')) {
        //Return true, if not all products can be selected
        const error_test = bundleVariantSelectChange(variant_arr, true);
        if (error_test) {
            const input = predefined_variant_elem.querySelector('input')
            input.setAttribute('aria-disabled', 'true');
            invalid_predefined_varant(input, true);
        }
    }

    predefined_variant_elem.addEventListener('change', function() {
        let error = false

        if (this.classList.contains('js-bundle__predefined-variant--custom')) {
            customVariant = true;
        }
        else {
            customVariant = false;
            error = bundleVariantSelectChange(variant_arr);
        }

        const predefined_variant_title = document.querySelector('.js-bundle-predefined-variant-title')
        if (predefined_variant_title) {
            predefined_variant_title.innerHTML = predefined_variant_input.dataset.title;
        }

        if (error) {
            predefined_variant_input.setAttribute('aria-disabled', 'true');
            document.querySelector('.js-bundle__predefined-variant input:not([aria-disabled="true"])').checked = true;
            alert(theme.strings.removeBundleError);
            return
        }

        updateHtmlPrice();
    })

    
});

/**
 * Update total price, when the individual variant is changed
 */
bundle_variant_elems.forEach(bundle_variant_elem => {
    const input = bundle_variant_elem.querySelector('input');
    input.addEventListener('change', function() {
        // if (!customVariant) return
        updateHtmlPrice();
    })
});

/**
 * Change variant size
 */
bundle_sizes.forEach(input => {
    input.addEventListener('change', function() {
        updateCurrentSize(input.value);
        updateHtmlPrice();
    })
});


bundle_containers.forEach((bundle_container, index) => {

    const bundle_container_elems = bundle_container.querySelectorAll('.js-bundle__variant');
    const product_id = bundle_container.dataset.productId;
    const container = document.getElementById(`bundle-container-${product_id}`);
    const title = container.querySelector('.js-bundle-variant-title');
    const subTitle = container.querySelector('.js-bundle-variant-subtitle');

    if (container.querySelector(".sold-out-pil-bundle")) {
        var bundleSoldOutPil = container.querySelector(".sold-out-pil-bundle");
    } else {
        var bundleSoldOutPil = null
    }

    bundle_container_elems.forEach(elem => {
        const label = elem.querySelector('label');
        const input = elem.querySelector('input');

        input.addEventListener('change', function(input) {

            console.log(input.target)

            if (input.target.getAttribute('aria-disabled') === 'true' && bundleSoldOutPil != null) {
                bundleSoldOutPil.style.display = "flex";
            } else if (bundleSoldOutPil != null) {
                bundleSoldOutPil.style.display = "none";
            }
            
            const section_quantity = data.bundleProducts[index].sizes.find(x => x.size == current_size).value;
            if (title) {
                title.innerHTML = `${ label.title }`;
            }
            if (subTitle) {
                subTitle.innerHTML = `${ section_quantity } ${ theme.strings?.pcs } `;
            }
        })
    });
});



window.addEventListener('load', function() {
    document.querySelector('.bundle__section').classList.remove('loading')
    document_ready = true;
    window.bundle = getFormData();
}, false);


document.addEventListener('cart:bundle-updated', function() {
    updateCartItemsWindowArr(updateBundle);
});


updateCartItemsWindowArr();
updateCurrentSize([...bundle_sizes].find(x => x.checked == true).value)
updateHtmlPrice();
